import { notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SubHeader from '../../../components/SubHeader';
import { FiltroProvider } from '../../../contexts/FilaEmbarque/Filtro';
import { toTitleCase } from '../../../helpers/formatador';
import geradorIdUnico from '../../../helpers/geradores';
import { gTagEntrada } from '../../../helpers/googleAnalytics';
import { getPagadores } from '../../../helpers/pagadores';
import { useAuth } from '../../../security/authContext';
import { checkPermission } from '../../../security/Can';
import apiNetCore from '../../../services/apiNetCore';
import { Spin, Tabs } from '../../../styles/global';
import DadosGerais from './DadosGerais';
import FilaEmbarque from './FilaEmbarque';
import Lotes from './Lotes';
import Performance from './Performance';
import { Background, Container, Rota } from './styles';

const { TabPane } = Tabs;

const Detalhe = () => {
  const params = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [detalhesDemanda, setDetalhesDemanda] = useState(null);
  const [eventId, setEventId] = useState('');
  const [enderecoExpedidor, setEnderecoExpedidor] = useState([]);
  const [enderecoRecebedor, setEnderecoRecebedor] = useState([]);
  const [compilados, setCompilados] = useState({
    volume: 0,
    saldo: 0,
    cadenciaDia: 0,
    aderenciaDiaPercentual: 0,
    aderenciaDiaTon: 0,
    aderenciaDia: 0,
    cotas: 0,
  });
  const [endereco, setEndereco] = useState({});
  const [dadosPagador, setDadosPagador] = useState({});

  const checkTabPermissao = permissao =>
    checkPermission(user.permissions, permissao);

  const hasPermissao = () =>
    checkTabPermissao('lotes:demanda:lotes') ||
    checkTabPermissao('lotes:demanda:performance');

  const tabs = [
    {
      key: '1',
      title: 'Fila de Embarque',
      permissao: 'lotes:show',
      content: detalhesDemanda && (
        <FiltroProvider>
          <FilaEmbarque
            detalhesDemanda={detalhesDemanda}
            idLotes={
              detalhesDemanda.lotes
                ? detalhesDemanda.lotes.map(lote => lote.idLote)
                : []
            }
            origem={detalhesDemanda.enderecoExpedidor[0]}
            destino={detalhesDemanda.enderecoRecebedor[0]}
          />
        </FiltroProvider>
      ),
    },
    {
      key: '2',
      permissao: 'lotes:demanda:lotes',
      title: 'Lotes',
      content: detalhesDemanda && (
        <Lotes
          idDemanda={params.demandaId}
          detalhesDemanda={detalhesDemanda}
          compilados={compilados}
          endereco={endereco}
          dadosPagador={dadosPagador}
        />
      ),
    },
    {
      key: '3',
      permissao: 'lotes:demanda:performance',
      title: 'Performance',
      content: <Performance />,
    },
    {
      key: '4',
      permissao: 'lotes:show',
      title: 'Dados gerais',
      content: <DadosGerais detalhesDemanda={detalhesDemanda} />,
    },
  ];

  const breadcrumbs = [
    {
      breadcrumbName: 'Demanda',
    },
    {
      breadcrumbName: 'Detalhes',
    },
  ];

  const onTabClickChange = value => setCurrentTab(Number(value));

  const createEventoGa = () => {
    const eventIdGerado = geradorIdUnico();
    setEventId(eventIdGerado);
    gTagEntrada(
      'Redirect - Detalhes da Demanda',
      'Demanda',
      'Acesso a detalhes da demanda.',
      eventIdGerado
    );
  };

  const onChangeTabEvent = activeKey => {
    gTagEntrada(
      `Click - Aba ${tabs[Number(activeKey) - 1].title}`,
      'Demanda',
      `Aba ${tabs[Number(activeKey) - 1].title} acessada.`,
      eventId
    );
  };

  useEffect(() => {
    const onInit = async () => {
      try {
        setLoading(true);

        const promises = [
          apiNetCore.get(`demanda/${params.demandaId}`),
          getPagadores(user),
        ];

        const promisesResolved = await Promise.all(promises);

        const dadosEndereco = {
          idEstadoOrigem:
            promisesResolved[0]?.data.enderecoExpedidor[0].idEstado ||
            promisesResolved[0]?.data.enderecoOrigem[0].idEstado,
          idEstadoDestino:
            promisesResolved[0]?.data.enderecoRecebedor[0].idEstado ||
            promisesResolved[0]?.data.enderecoDestino[0].idEstado,
          idCidadeOrigem:
            promisesResolved[0]?.data.enderecoExpedidor[0].idCidade ||
            promisesResolved[0]?.data.enderecoOrigem[0].idCidade,
          idCidadeDestino:
            promisesResolved[0]?.data.enderecoRecebedor[0].idCidade ||
            promisesResolved[0]?.data.enderecoDestino[0].idCidade,
          ibgeOrigem:
            promisesResolved[0]?.data.enderecoExpedidor[0].ibgeCidade ||
            promisesResolved[0]?.data.enderecoOrigem[0].ibgeCidade,
          ibgeDestino:
            promisesResolved[0]?.data.enderecoRecebedor[0].ibgeCidade ||
            promisesResolved[0]?.data.enderecoDestino[0].ibgeCidade,
        };
        setEndereco(dadosEndereco);

        setDetalhesDemanda(promisesResolved[0].data);
        setEnderecoExpedidor(promisesResolved[0]?.data.enderecoExpedidor);
        setEnderecoRecebedor(promisesResolved[0]?.data.enderecoRecebedor);
        setCompilados({
          volume: promisesResolved[0]?.data.volumeTotal,
          saldo: promisesResolved[0]?.data.saldo,
          cadenciaDia: promisesResolved[0]?.data.cadenciaDiariaTotal,
          aderenciaDiaPercentual:
            promisesResolved[0]?.data.aderenciaDiaPercentual,
          aderenciaDiaTon: promisesResolved[0]?.data.aderenciaDiaTon,
          cotas: promisesResolved[0]?.data.caminhoesMovimentadosHoje,
        });

        if (promisesResolved[1]) {
          const pagador = promisesResolved[1].find(
            apiPagador =>
              apiPagador.id === promisesResolved[0]?.data.idClientePagador
          );
          setDadosPagador(pagador);
        }

        createEventoGa();
      } catch (error) {
        notification.error({
          message: 'Ops, não foi possível carregar demanda.',
          description:
            'Caso o problema persista, entre em contato com nosso suporte.',
        });
      } finally {
        setLoading(false);
      }
    };

    onInit();
  }, [params]);

  return (
    <Background>
      <SubHeader breadcrumbs={breadcrumbs} />
      <Container>
        <h1>
          <b>Demanda</b>
          &nbsp;
          {`D${params.demandaId.padStart(5, '0')}`}
        </h1>
        <Rota>
          {!loading &&
            `${toTitleCase(String(enderecoExpedidor[0]?.cidade))} (${
              enderecoExpedidor[0]?.estado
            })
              -
              ${toTitleCase(String(enderecoRecebedor[0]?.cidade))} (${
              enderecoRecebedor[0]?.estado
            })`}
        </Rota>
        {loading ? (
          <Spin style={{ width: '100%' }} />
        ) : (
          <Tabs
            activeKey={currentTab.toString()}
            onTabClick={onTabClickChange}
            onChange={onChangeTabEvent}
            style={{ overflow: 'visible' }}
            tabBarGutter={hasPermissao() ? 25 : 10}
          >
            {tabs.map(
              item =>
                checkTabPermissao(item.permissao) && (
                  <TabPane tab={item.title} key={item.key}>
                    {item.content}
                  </TabPane>
                )
            )}
          </Tabs>
        )}
      </Container>
      <div style={{ height: '1px' }} />
    </Background>
  );
};

export default Detalhe;
